export enum SubscriberStatus {
  Pending = 1,
  Active = 2,
  Deleted = 3,
}
